export default __webpack_public_path__ + "static/media/whitemoneda.d540d2ed.svg";